import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/material/styles';

const getTitleTypographyVariant = (
  variant: 'section' | 'subhead' | 'summary' | 'field' | 'drawer'
) => {
  switch (variant) {
    case 'section':
      return 'sectionTitle';
    case 'subhead':
      return 'subTitle';
    case 'field':
      return 'field';
    case 'drawer':
      return 'drawer';
  }
};

type Props = {
  title?: string | undefined | React.ReactNode;
  subtitle?: string | React.ReactElement | undefined;
  variant: 'section' | 'subhead' | 'field' | 'drawer';
  sx?: SxProps;
  titleSx?: SxProps;
  subtitleSx?: SxProps;
};

type PxValue = `${number}px`;

const getGap = (
  variant: 'section' | 'subhead' | 'field' | 'drawer'
): PxValue => {
  switch (variant) {
    case 'field':
      return '3px';
    case 'section':
      return '5px';
    default:
      return '10px';
  }
};

export const TextBlock: React.FC<Props> = ({
  title,
  subtitle,
  variant,
  sx,
  titleSx,
  subtitleSx
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: getGap(variant),
        color: 'customGrey.dark',
        ...sx
      }}
    >
      {title && (
        <Typography variant={getTitleTypographyVariant(variant)} sx={titleSx}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography
          sx={{
            fontSize: '16px',
            lineHeight: '26px',
            color: 'customGrey.dark',
            whiteSpace: 'pre-line',
            ...subtitleSx
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
